import {ImpressaoService} from "../../services/impressao.service";
import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {DeviceDetectorService} from "ngx-device-detector";


@Component({
  selector: 'app-qztray-detect',
  templateUrl: './qztray.detect.component.html',
  styleUrls: ['./qztray.detect.component.scss']
})
export class QztrayDetectComponent implements OnInit {
  conectando = true;
  qzInstalado   = false;
  isMobile =  false;
  @Input() titulo = ''; //Impressão nativa
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onConectou  = new EventEmitter();
  constructor( public impressao: ImpressaoService,
               private deviceService: DeviceDetectorService) {
    this.isMobile = this.deviceService.isMobile()
    if(this.isMobile) this.conectando = false;
  }

  ngOnInit(): void {
    if(this.impressao.conectando && !this.isMobile) {
      this.impressao.conectou.subscribe((conectou: boolean) => {
        this.conectando = false
        this.qzInstalado = conectou;
        if(conectou) {
          this.onConectou.emit({})
        }
      })
    } else {
      this.conectando = false;
      this.qzInstalado = this.impressao.qzInstalado
      if(this.qzInstalado) {
        this.onConectou.emit({})
      }
    }
  }


  abraQZTray() {
    // Usar o protocolo URL qz:launch para abrir o QZ Tray
    window.location.href = 'qz:launch';

    // Esperar um pouco e tentar reconectar
    setTimeout(() => {
      this.tenteConectarQZ();
    }, 3000);
  }


  tenteConectarQZ() {
    this.conectando = true;
    this.impressao.possuiQZ().then((possui: boolean) => {
      this.conectando = false;
      this.qzInstalado = possui;

      if(possui) this.onConectou.emit({})
        //this.carregueImpressoras()
    })
  }



}
